import axios from "axios";


const API = axios.create({

    baseURL: `${process.env.REACT_APP_BACKEND_URI}/api`

});




// KPI Cards

export const getReportSummary = async()=>{

    const response = await API.get(
        "/reports/summary"
    );

    return response.data;

};




// Status Chart

export const getTicketStatusReport = async()=>{

    const response = await API.get(
        "/reports/status"
    );

    return response.data;

};




// Priority Chart

export const getPriorityReport = async()=>{

    const response = await API.get(
        "/reports/priority"
    );

    return response.data;

};




// Category Chart

export const getCategoryReport = async()=>{

    const response = await API.get(
        "/reports/category"
    );

    return response.data;

};




// Monthly Trend

export const getMonthlyTrend = async()=>{

    const response = await API.get(
        "/reports/trend"
    );

    return response.data;

};




// Resolution Time

export const getResolutionTimeReport = async()=>{

    const response = await API.get(
        "/reports/resolution-time"
    );

    return response.data;

};




// SLA

export const getSLAReport = async()=>{

    const response = await API.get(
        "/reports/sla"
    );

    return response.data;

};




// Recent Tickets

export const getRecentTickets = async()=>{

    const response = await API.get(
        "/reports/recent"
    );

    return response.data;

};



export default API;